import {FetchService} from '../fetch/fetch.service';
import {SendEmailParams, SentMessageInfo} from '../../shared/email/email.class';

export class EmailService {
    constructor(private _fetchService: FetchService) {}

    /**
     * Takes CMS generated email form and sends an email
     * @param sendEmailParams - Inputs from CMS form
     */
    public sendEmail(sendEmailParams: SendEmailParams) {
        return this._fetchService.post<SentMessageInfo>(`/api/email/sendEmail`, sendEmailParams);
    }
}
